export default __webpack_public_path__ + "static/media/VehicleHealth.39933147.png";